import React from 'react';
import { SectionTitle } from './SectionTitle';
import { Chips } from './Chips';
import { modules } from '../data/salesCopy';
export function ModulesSection() {
  return <section className="bg-brand-ivory px-4 py-8 sm:py-10" data-id="element-148" data-mp="1nstm27b7pgtg">
      <div className="mx-auto max-w-4xl" data-id="element-149" data-mp="1iw341efukb5e">
        <SectionTitle data-id="element-150" data-mp="1dwi719k8mcvb">WHAT'S INSIDE</SectionTitle>

        <div className="mt-5 space-y-3" data-id="element-151" data-mp="1dxt5quytsufk">
          {modules.map(mod => <article key={mod.n} className="overflow-hidden rounded-lg border border-brand-sand/70 bg-white shadow-sm" data-id="element-152" data-mp="2bkii9yr5mpfo">
              <header className="flex items-center gap-2.5 bg-brand-sage px-3 py-2 sm:px-4" data-id="element-153" data-mp="26jb5tme2h22o">
                <span className="shrink-0 rounded bg-brand-gold px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wider text-brand-charcoal" data-id="element-154" data-mp="21nvzdfie28ga">
                  Module {mod.n}
                </span>
                <h3 className="font-serif text-[15px] font-extrabold uppercase leading-tight text-white sm:text-lg" data-id="element-155" data-mp="l7t0uw4brhcp">
                  {mod.title}
                </h3>
              </header>

              <div className="space-y-2.5 p-3 sm:p-4" data-id="element-156" data-mp="1ite64jrz230e">
                <p className="text-[13px] font-bold leading-snug text-brand-sage sm:text-[14.5px]" data-id="element-157" data-mp="1nt0iys3w1h8o">
                  {mod.hook}
                </p>
                <p className="text-[12.5px] font-medium leading-snug text-brand-charcoal/85 sm:text-[13.5px]" data-id="element-158" data-mp="1dw5lmcjcpmvz">
                  {mod.lead}
                </p>
                <Chips items={mod.bullets} data-id="element-159" data-mp="10367oez7w0qj" />

                {mod.secondLead && mod.secondBullets && <>
                    <p className="text-[12.5px] font-medium leading-snug text-brand-charcoal/85 sm:text-[13.5px]" data-id="element-160" data-mp="14xaft1k7yet7">
                      {mod.secondLead}
                    </p>
                    <Chips items={mod.secondBullets} tone="sage" data-id="element-161" data-mp="v5xn67qljkm4" />
                  </>}

                {mod.notes.map(note => <p key={note} className="text-[12.5px] font-medium leading-snug text-brand-charcoal/75 sm:text-[13.5px]" data-id="element-162" data-mp="l7zzpmgk9ruk">
                    {note}
                  </p>)}

                <p className="border-t border-brand-sand/50 pt-2 text-[12.5px] font-extrabold uppercase leading-snug tracking-wide text-brand-clay sm:text-[13.5px]" data-id="element-163" data-mp="2j2438xd5kufc">
                  {mod.close}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}